module.exports = __webpack_public_path__ + "img/logo_gutenberg-one.ddf22960.png";